require('./dist/angular-filter.js');
module.exports = 'angular.filter';



//////////////////
// WEBPACK FOOTER
// ./~/angular-filter/index.js
// module id = ./node_modules/angular-filter/index.js
// module chunks = 1